"use strict";
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null);
  }
});
